const publicUrl = process.env.PUBLIC_URL || '';

const teaImmunityCarouselItems = [
  {
    id: 'tea-chakra',
    title: 'Чакра',
    category: 'Билков чай',
    price: 'От 3,53 €',
    src: `${publicUrl}/images/tea/chakra-tea.webp`,
    product: {
      title: 'Чакра',
      description: 'Балансирана билкова смес за спокойна пауза и ежедневен уют.',
      ingredients: 'Билки и цветни листенца',
    },
  },
  {
    id: 'tea-lemongrass',
    title: 'Лимонена трева',
    category: 'Билков чай',
    price: 'От 2,81 €',
    src: `${publicUrl}/images/tea/lemongrass-tea.webp`,
    product: {
      title: 'Лимонена трева',
      description: 'Свеж билков чай с лек цитрусов аромат.',
      ingredients: 'Лимонена трева',
    },
  },
  {
    id: 'tea-fig-leaves',
    title: 'Fig Leaves Tea',
    category: 'Билков чай',
    price: 'От 3,90 €',
    src: `${publicUrl}/images/tea/fig-leaves-tea.webp`,
    product: {
      title: 'Fig Leaves Tea',
      description: 'Нежен билков чай от ароматни смокинови листа с мек, зелен вкус.',
      ingredients: 'Смокинови листа',
    },
  },
  {
    id: 'tea-mate',
    title: 'Мате',
    category: 'Мате чай',
    price: 'От 2,51 €',
    src: `${publicUrl}/images/tea/mate-tea.webp`,
    product: {
      title: 'Мате',
      description: 'Ароматен мате чай с естествено свеж и тонизиращ характер.',
      ingredients: 'Мате',
    },
  },
  {
    id: 'tea-fasting',
    title: 'Чай за пост',
    category: 'Аюрведичен чай',
    price: 'От 3,83 €',
    src: `${publicUrl}/images/tea/tea-carousel.webp`,
    backgroundPosition: '75% 55%',
    backgroundSize: '500% auto',
    product: {
      title: 'Чай за пост',
      description: 'Мека аюрведична смес за лекота и баланс.',
      ingredients: 'Билки и подправки',
    },
  },
  {
    id: 'tea-mursal',
    title: 'Мурсалски чай',
    category: 'Билков чай',
    price: 'От 3,53 €',
    src: `${publicUrl}/images/tea/mursalski-tea.webp`,
    product: {
      title: 'Мурсалски чай',
      description: 'Ароматен планински билков чай с чист и свеж вкус.',
      ingredients: 'Мурсалски чай',
    },
  },
];

const teaEnergyExtras = [
  {
    id: 'tea-star-dust',
    title: 'Звезден прах',
    category: 'За енергия',
    price: 'От 4,20 €',
    src: `${publicUrl}/images/tea/star-dust-tea.webp`,
    product: {
      title: 'Звезден прах',
      description: 'Цветна и ароматна смес за свежо настроение и енергичен ден.',
      ingredients: 'Билки, цветя и плодове',
    },
  },
  {
    id: 'tea-truffle',
    title: 'Трюфел чай',
    category: 'За енергия',
    price: 'От 4,50 €',
    src: `${publicUrl}/images/tea/truffle-tea.webp`,
    product: {
      title: 'Трюфел чай',
      description: 'Богат чай с уютен аромат и мек, дълбок вкус.',
      ingredients: 'Чай, какао и ванилия',
    },
  },
  {
    id: 'tea-sea-breeze',
    title: 'Sea Breeze',
    category: 'За енергия',
    price: 'От 4,20 €',
    src: `${publicUrl}/images/tea/sea-breeze-tea.webp`,
    product: {
      title: 'Sea Breeze',
      description: 'Свежа смес с лек цитрусов аромат и чист морски характер.',
      ingredients: 'Билки, цитрус и цветя',
    },
  },
  {
    id: 'tea-caramel',
    title: 'Карамел чай',
    category: 'За енергия',
    price: 'От 4,20 €',
    src: `${publicUrl}/images/tea/caramel-tea.webp`,
    product: {
      title: 'Карамел чай',
      description: 'Топъл карамелен аромат за сладък старт и приятна пауза.',
      ingredients: 'Чай, карамел и ванилия',
    },
  },
];

const teaEnergyCarouselItems = [
  ...teaImmunityCarouselItems.map((item, index) => ({
    ...item,
    id: `${item.id}-energy`,
    category: 'За енергия',
    product: {
      ...item.product,
      title: `${item.product.title} — енергия`,
      description: 'Свеж чай за добър старт и повече енергия през деня.',
    },
    backgroundPosition: item.backgroundSize ? `${index * 25}% 55%` : 'center',
    backgroundSize: item.backgroundSize || 'cover',
  })),
  ...teaEnergyExtras,
];

const teaFavoritesCarouselItems = [
  ...teaImmunityCarouselItems,
  ...teaEnergyExtras,
];

const teaConnoisseurCarouselItems = [
  teaImmunityCarouselItems[5],
  teaImmunityCarouselItems[3],
  teaEnergyExtras[0],
  teaEnergyExtras[3],
].map(item => ({
  ...item,
  id: `${item.id}-connoisseur`,
  category: 'За ценители',
  product: {
    ...item.product,
    description: 'Подбрана селекция за любителите на отличния чай.',
  },
}));

export {
  teaImmunityCarouselItems,
  teaEnergyCarouselItems,
  teaFavoritesCarouselItems,
  teaConnoisseurCarouselItems,
};
